import * as Cesium from 'cesium'
import { EarthMesh } from './EarthMesh'
import CesiumTools from './CesiumTools'

export const ZoneOfInterest = {
  mixins: [EarthMesh],
  data() {
    return {
      selector: null,
      rectangleSelector: new Cesium.Rectangle(),
      cartesian: new Cesium.Cartesian3(),
      tempCartographic: new Cesium.Cartographic(),
      center: new Cesium.Cartographic(),
      firstPoint: new Cesium.Cartographic(),
      firstPointSet: false,
      mouseDown: false,
      poiDatasource: null,
      pinIconUrl: null,
      cameraShouldFly: true
    }
  },
  methods: {
    initPOIDataSource() {
      this.poiDatasource = new Cesium.CustomDataSource('poiDataSource')
      this.viewer.dataSources.add(this.poiDatasource)
      this.pinIconUrl = require('../../assets/images/Google_Maps_pin.svg')
    },

    onMorphComplete() {
      this.viewer.entities.values.forEach((entity) => {
        if (entity.billboard) {
          entity.billboard.heightReference =
            this.viewer.scene.mode === Cesium.SceneMode.SCENE3D
              ? Cesium.HeightReference.CLAMP_TO_GROUND
              : Cesium.HeightReference.NONE
        }
      })
    },

    createPinEntity(cartesian, name) {
      return {
        position: cartesian,
        label: {
          show: true,
          text: name,
          showBackground: true,
          font: '14px monospace',
          horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
          verticalOrigin: Cesium.VerticalOrigin.TOP,
          pixelOffset: new Cesium.Cartesian2(5, 0),
          eyeOffset: new Cesium.Cartesian3(0, 0, -1e6)
        },
        billboard: {
          image: this.pinIconUrl,
          heightReference:
            this.viewer.scene.mode === Cesium.SceneMode.SCENE3D
              ? Cesium.HeightReference.CLAMP_TO_GROUND
              : Cesium.HeightReference.NONE,
          pixelOffset: new Cesium.Cartesian2(0, -17)
        }
      }
    },

    onPoiListChange(poiList) {
      this.poiDatasource.entities.removeAll()
      if (this.poiDatasource) {
        this.viewer.dataSources.remove(this.poiDatasource, true)
      }
      if (!poiList) {
        return
      }
      let tmpCartesian = new Cesium.Cartesian3()
      poiList.forEach((poi) => {
        tmpCartesian = Cesium.Cartesian3.fromDegrees(
          CesiumTools.toDegrees(poi.longitude),
          CesiumTools.toDegrees(poi.latitude),
          10e3
        )
        this.poiDatasource.entities.add(
          this.createPinEntity(tmpCartesian, poi.name)
        )
        tmpCartesian = Cesium.Cartesian3.fromDegrees(
          CesiumTools.toDegrees(poi.longitude),
          CesiumTools.toDegrees(poi.latitude),
          1e7
        )
        if (this.cameraShouldFly) {
          this.viewer.camera.flyTo({ destination: tmpCartesian })
        }
      })
      this.viewer.dataSources.add(this.poiDatasource)
    },

    onMeshesListChange(meshes, listOfPointsList) {
      let meshCopies = []
      this.removeAllPrimitives()
      if (!meshes || !meshes.length) {
        return
      }
      meshes.forEach((mesh) => {
        meshCopies.push(this.onMeshUpdate(mesh, true))
      })
      setTimeout(() => {
        this.createRectanglePrimitives(meshCopies, listOfPointsList)
      }, 100)
    }
  }
}
